<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <div class="brand" style="color:#fff">ERP</div>
          </span>
          <span class="logo-lg">
            <div class="brand" style="color:#fff">ERP</div>
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
          <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="16"> <span
            class="ms-1">{{countryName}}</span>
          <img *ngIf="flagvalue === undefined" src="{{valueset}}" alt="Header Language" height="16">
          <span *ngIf="flagvalue === undefined" class="ms-1">English</span>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item notify-item" *ngFor="let item of listLang"
            (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
            <img src="{{item.flag}}" alt="user-image" class="me-1" height="12"> <span
              class="align-middle">{{item.text}}</span>
          </a>
          <!-- item-->
        </div>
      </div>

      <div class="dropdown  d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" (click)="GetNotificationsMessages()" class="btn header-item noti-icon"
          id="page-header-notifications-dropdown" ngbDropdownToggle>
          <i class="bx bx-bell" [class]="notiLength > 0 ? 'bx-tada':''"></i>
          <span *ngIf="notiLength > 0" class="badge bg-danger rounded-pill">{{notiLength}}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ 'HEADER.NOTIFICATIONS.TITLE' | translate}} </h6>
              </div>
              <!-- <div class="col-auto">
                <a href="javascript: void(0);" class="small">{{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate}}</a>
              </div> -->
            </div>
          </div>
          <div>
            <ng-container *ngIf="loader">
              <div class="d-flex justify-content-center align-items-center" style="min-height: 220px;">
                <div class="spinner-border text-primary m-1" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </ng-container>
          </div>
          <ngx-simplebar *ngIf="!loader" style="position: relative;">
            <div class="main-panel">
              <div class="search-results" infinite-scroll [infiniteScrollDistance]="1"
                [infiniteScrollThrottle]="messageNotification?.totalRecords" [infiniteScrollContainer]="'.main-panel'"
                [fromRoot]="true" (scrolled)="InfiniteScroll()">
                <ng-container *ngFor="let item of messageNotification?.data">
                  <a href="javascript: void(0);" class="text-reset notification-item"
                    (click)="routingNotifications(item)">
                    <div class="media" [class]="!item.isRead ? 'badge badge-soft-primary text-start':''">
                      <!-- <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic"> -->
                      <div class="media-body">
                        <h6 class="mt-0 mb-1">{{item.type}}</h6>
                        <div class="font-size-12 text-muted">
                          <p class="mb-1">{{ item.description}}</p>
                          <p class="mb-0"><i class="bx bx-calendar"></i>{{item.dateTime | date: 'long'}}</p>
                        </div>
                      </div>
                    </div>
                  </a>
                </ng-container>
                <ng-container *ngIf=" messageNotification?.data.length == 0">
                  <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
                    <div class="alert alert-warning fade text-center show px-3 mb-0" role="alert">
                      <div class="mb-3">
                        <i class="bx bx-error-alt h1  text-warning"></i>
                      </div>
                      <div class="text-center">
                        <h5 class="text-warning ">Not Found Notification</h5>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="loading-more" *ngIf="loadingMore">
              <div class="d-flex justify-content-center align-items-center" style="min-height: 24px;">
                <div class="spinner-border text-primary m-1" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </ngx-simplebar>
          <!-- <div class="p-2 border-top d-grid">
            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{{
                'HEADER.NOTIFICATIONS.LOAD_MORE' | translate}}</span>
            </a>
          </div> -->
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item d-flex align-items-center" ngbDropdownToggle
          id="page-header-user-dropdown">
          <div class="avatar-xs rounded-circle header-profile-user">
            <span class="avatar-title rounded-circle">
              {{user.charAt(0)}}
            </span>
          </div>
          <span class="d-none d-xl-inline-block ms-1">{{user}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <a class="dropdown-item" routerLink="/profile"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'GENERAL.LOGOUT' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</header>